import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Mail } from 'lucide-react';

const Header = () => {
  return (
    <header className="nav-header">
      <div className="nav-logo">
        <Link to="/" className="logo-link">
          <BookOpen className="logo-icon" />
          <span className="logo-text">StudioInsieme</span>
        </Link>
      </div>
      
      <nav className="nav-menu">
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/contatti" className="nav-link">Contatti</Link>
        <Link to="/iscrizione" className="nav-link nav-link-cta">Iscriviti</Link>
      </nav>
    </header>
  );
};

export default Header;
